// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"e20c5a7ef4c5e717c679","276":"6b5acc8b6933194b675f"}[chunkId] + ".js";
};